import React from "react";
import { CompanyMultiStepForm } from "../../components/auth/CompanyMultiStepForm";
import { CompanySteps } from "../../config/CompanySteps";
import { CompanyLayout } from "../../layouts/CompanyLayout";
import MainStyle from "../../style/Main.module.css";
import images from "../../utils/images";
// import { useNavigate } from "react-router-dom";
// import { isAuthenticated } from "../../utils/authenticated";
import { useCompany } from "../../hooks/useAuth";
import { isAuthenticated } from "../../utils/authenticated";
import { Navigate } from "react-router-dom";

export const CompanyPage = () => {
  // const navigate = useNavigate();
  const {
    currentStep,
    formData,
    stepErrors,
    isSubmitting,
    handleChange,
    nextStep,
    prevStep,
    setSelectedImage,
    selectedImage,
  } = useCompany({
    steps: CompanySteps,
  });

  // useEffect(() => {
  //   if (!isAuthenticated()) {
  //     navigate("/");
  //   } else if (companyDetails) {
  //     navigate("/homepage");
  //   }
  // }, [navigate, companyDetails]);
  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }
  return (
    <CompanyLayout>
      <div>
        <div className={MainStyle.logoview}>
          <img src={images.logoimg} alt="Company Logo" />
        </div>
        {/* <div
          style={{ color: "green", cursor: "pointer" }}
          onClick={handleLogout}
        >
          Signout <AiOutlineLogout />
        </div> */}
      </div>

      <CompanyMultiStepForm
        steps={CompanySteps}
        currentStep={currentStep}
        formData={formData}
        errors={stepErrors}
        isSubmitting={isSubmitting}
        onChange={handleChange}
        onNext={nextStep}
        onBack={prevStep}
        setSelectedImage={setSelectedImage}
        selectedImage={selectedImage}
      />
    </CompanyLayout>
  );
};
